const SESSION_USER_EMAIL_KEY = "userEmail";
const SESSION_USER_ID_KEY = "userId";
const SESSION_ID_KEY = "sessionId";
const SESSION_CREATED_AT_KEY = "sessionCreatedAt";
const SESSION_LAST_ACTIVITY_KEY = "lastActivityAt";

export const SESSION_IDLE_TIMEOUT_MS = 24 * 60 * 60 * 1000;

export const clearClientSession = () => {
  localStorage.removeItem(SESSION_USER_EMAIL_KEY);
  localStorage.removeItem(SESSION_USER_ID_KEY);
  localStorage.removeItem(SESSION_ID_KEY);
  localStorage.removeItem(SESSION_CREATED_AT_KEY);
  localStorage.removeItem(SESSION_LAST_ACTIVITY_KEY);
  localStorage.removeItem("authToken");
};

export const setClientSession = ({ userEmail, userId, sessionId }) => {
  const stamp = String(Date.now());

  localStorage.setItem(SESSION_USER_EMAIL_KEY, userEmail || "");
  localStorage.setItem(SESSION_USER_ID_KEY, userId || "");
  localStorage.setItem(SESSION_ID_KEY, sessionId || "");
  localStorage.setItem(SESSION_CREATED_AT_KEY, stamp);
  localStorage.setItem(SESSION_LAST_ACTIVITY_KEY, stamp);
};

export const markSessionActivity = () => {
  const stamp = String(Date.now());
  if (!localStorage.getItem(SESSION_CREATED_AT_KEY)) {
    localStorage.setItem(SESSION_CREATED_AT_KEY, stamp);
  }
  localStorage.setItem(SESSION_LAST_ACTIVITY_KEY, stamp);
  return Number(stamp);
};

export const getClientSession = () => ({
  userEmail: localStorage.getItem(SESSION_USER_EMAIL_KEY) || "",
  userId: localStorage.getItem(SESSION_USER_ID_KEY) || "",
  sessionId: localStorage.getItem(SESSION_ID_KEY) || "",
  createdAt: Number(localStorage.getItem(SESSION_CREATED_AT_KEY) || 0),
  lastActivityAt: Number(localStorage.getItem(SESSION_LAST_ACTIVITY_KEY) || 0),
});

export const isClientSessionExpired = (timeoutMs = SESSION_IDLE_TIMEOUT_MS) => {
  const { createdAt, lastActivityAt } = getClientSession();
  const baseline = Math.max(createdAt || 0, lastActivityAt || 0);
  if (!baseline) {
    return true;
  }

  return Date.now() - baseline >= timeoutMs;
};
